<div class="cell auto grid-y cell-block-y blockContent" *ngIf="study">
    <table>
        <thead>
        <tr class="_titlePartTable">
            <th colspan="2"[i18nKey]="'studies.cash.flow.statement.cash.in'"></th>
            <th colspan="2"[i18nKey]="'studies.cash.flow.statement.cash.out'"></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr>
            <td [i18nKey]="'studies.cash.flow.statement.wines.turnover.including.taxes'"></td>
            <td class="_number">{{study.cashIn.winesTurnoverIncludingTaxes | number:'1.2'}}</td>
            <td [i18nKey]="'studies.cash.flow.statement.wines.purchasing.costs.including.taxes'"></td>
            <td class="_number">{{study.cashOut.winesPurchasesIncludingTaxes | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.cash.flow.statement.dishes.turnover.including.taxes'"></td>
            <td class="_number">{{study.cashIn.dishesTurnoverIncludingTaxes | number:'1.2'}}</td>
            <td [i18nKey]="'studies.cash.flow.statement.ingredients.purchasing.costs.including.taxes'"></td>
            <td class="_number">{{study.cashOut.ingredientsPurchasesIncludingTaxes | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.cash.flow.statement.other.operating.products'"></td>
            <td class="_number">{{study.cashIn.otherOperatingProductsIncludingTaxes | number:'1.2'}}</td>
            <td [i18nKey]="'studies.cash.flow.statement.other.operating.charges'"></td>
            <td class="_number">{{study.cashOut.otherOperatingChargesIncludingTaxes | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.cash.flow.statement.layout.selling.income'"></td>
            <td class="_number">{{study.cashIn.layoutSellingIncomeIncludingTaxes | number:'1.2'}}</td>
            <td [i18nKey]="'studies.cash.flow.statement.layout.purchase.cost'"></td>
            <td class="_number">{{study.cashOut.layoutPurchaseCostIncludingTaxes | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.cash.flow.statement.vat.refund'"></td>
            <td class="_number">{{study.cashIn.refundVat | number:'1.2'}}</td>
            <td [i18nKey]="'studies.cash.flow.statement.external.loads'"></td>
            <td class="_number">{{study.cashOut.externalLoadsIncludingTaxes | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.cash.flow.statement.income.tax'"></td>
            <td class="_number">{{study.cashIn.incomePaymentInAdvanceReimbursement | number:'1.2'}}</td>
            <td [i18nKey]="'studies.cash.flow.statement.vat.paid'"></td>
            <td class="_number">{{study.cashOut.vatPaid | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.cash.flow.statement.investment.interest'"></td>
            <td class="_number">{{study.cashIn.investmentInterest | number:'1.2'}}</td>
            <td [i18nKey]="'studies.cash.flow.statement.other.financial.expenses'"></td>
            <td class="_number">{{study.cashOut.otherFinancialExpensesIncludingTaxes | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.cash.flow.statement.other.financial.products'"></td>
            <td class="_number">{{study.cashIn.otherFinancialProducts | number:'1.2'}}</td>
            <td [i18nKey]="'studies.cash.flow.statement.other.non.recurring.charges'"></td>
            <td class="_number">{{study.cashOut.otherNonRecurringChargeIncludingTaxes | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.cash.flow.statement.other.exceptional.income'"></td>
            <td class="_number">{{study.cashIn.otherExceptionalIncomeIncludingTaxes | number:'1.2'}}</td>
            <td [i18nKey]="'studies.cash.flow.statement.advance.tax.payment'"></td>
            <td class="_number">{{study.cashOut.advanceTaxPayment | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.cash.flow.statement.amount.newly.borrowed'"></td>
            <td class="_number">{{study.cashIn.amountNewlyBorrowed | number:'1.2'}}</td>
            <td [i18nKey]="'studies.cash.flow.statement.income.tax'"></td>
            <td class="_number">{{study.cashOut.incomeTax | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.cash.flow.statement.amount.withdrawn.from.savings'"></td>
            <td class="_number">{{study.cashIn.amountWithdrawnFromSavings | number:'1.2'}}</td>
            <td [i18nKey]="'studies.cash.flow.statement.wage.bills'"></td>
            <td class="_number">{{study.cashOut.wageBills | number:'1.2'}}</td>
        </tr>

        <tr>
            <td></td>
            <td></td>
            <td [i18nKey]="'studies.cash.flow.statement.loan.amount.repaid'"></td>
            <td class="_number">{{study.cashOut.loanAmountRepaid | number:'1.2'}}</td>
        </tr>

        <tr>
            <td></td>
            <td></td>
            <td [i18nKey]="'studies.cash.flow.statement.amount.newly.invested'"></td>
            <td class="_number">{{study.cashOut.amountNewlyInvested | number:'1.2'}}</td>
        </tr>

        <tr>
            <td></td>
            <td></td>
            <td [i18nKey]="'studies.cash.flow.statement.social.charges'"></td>
            <td class="_number">{{study.cashOut.socialCharges | number:'1.2'}}</td>
        </tr>

        <tr>
            <td></td>
            <td></td>
            <td [i18nKey]="'studies.cash.flow.statement.loan.interest'"></td>
            <td class="_number">{{study.cashOut.loanInterest | number:'1.2'}}</td>
        </tr>

        <tr>
            <td></td>
            <td></td>
            <td [i18nKey]="'studies.cash.flow.statement.overdraft.charges'"></td>
            <td class="_number">{{study.cashOut.overdraftCharges | number:'1.2'}}</td>
        </tr>

        <tr>
            <td class="text-right _totalColumn"[i18nKey]="'studies.cash.flow.statement.total.cash.in'"></td>
            <td class="_number _totalColumn">{{study.cashIn.totalCashIn | number:'1.2'}}</td>
            <td class="text-right _totalColumn"[i18nKey]="'studies.cash.flow.statement.total.cash.out'"></td>
            <td class="_number _totalColumn">{{study.cashOut.totalCashOut | number:'1.2'}}</td>
        </tr>
        </tbody>
    </table>

    <kiwi-spacer [size]="40"></kiwi-spacer>

    <div class="studyTreasury">
        <div class="studyTreasury-initial">
            <span
                class="studyTreasury-initial-label"[i18nKey]="'studies.cash.flow.statement.initial.balance'"></span>
            <span class="studyTreasury-initial-value">{{study.initialTreasury | number:'1.2'}}</span>
        </div>
        <div class="studyTreasury-difference"><span [i18nKey]="'studies.cash.flow.statement.difference.balance'"></span>
            <span class="studyTreasury-difference-value">{{(study.finalTreasury - study.initialTreasury) | number:'1.2'}}</span>
        </div>
        <div class="studyTreasury-final">
            <span
                class="studyTreasury-final-label"[i18nKey]="'studies.cash.flow.statement.final.balance'"></span>
            <span class="studyTreasury-final-value">{{study.finalTreasury | number:'1.2'}}</span>
        </div>
    </div>
</div>
